import { raundUrl } from '@/lib/custom'
import type { RootState } from '@/store/store'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { availableState } from '@/features/authSlice'
import { dialogRegisterQuestionnaireState } from '@/features/dialogSlice'
import { useCampaignHeaders } from '@/lib/useCampaignHeaders'
import { useCampaignSlug } from '@/lib/useCampaignSlug'

const useNoLogin = () => {
  const dispatch = useDispatch()
  const { headers } = useCampaignHeaders()
  const router = useRouter()
  const { LOCAL_STORAGE_USERNAME_KEY, LOCAL_STORAGE_JWT_KEY, LOCAL_STORAGE_REFRESH_KEY, gen } = useCampaignSlug()

  const loginTypeStateSelector = useSelector((state: RootState) => state.auth.loginType)

  const NoAuthLoginFunc = async () => {
    try {
      /***
       * アカウント登録(バックエンドで登録)
       */
      const cognitoRegisterFunc = await fetch(raundUrl.register, {
        method: 'POST',
        headers,
      })

      const result = await cognitoRegisterFunc.json()

      if (result.status === 200) {
        localStorage.setItem(LOCAL_STORAGE_JWT_KEY, `${result.id_token}`)
        localStorage.setItem(LOCAL_STORAGE_REFRESH_KEY, `${result.refresh_token}`)
        localStorage.setItem(LOCAL_STORAGE_USERNAME_KEY, `${result.username}`)

        dispatch(dialogRegisterQuestionnaireState(true))

        return
      }

      if (result.status === 400) {
        dispatch(availableState(false))
        throw new Error('登録時にエラーが発生しました')
      }
    } catch (error) {
      dispatch(availableState(false))
      throw new Error('登録時にエラーが発生しました')
    }
  }

  useEffect(() => {
    if (loginTypeStateSelector === 9) {
      try {
        if (!localStorage.getItem(LOCAL_STORAGE_JWT_KEY)) {
          NoAuthLoginFunc()
            .then(() => router.push(gen('/')))
            .catch((e) => {
              const currentUrl = window.location.href
              if (!currentUrl.includes('/auth/signin')) {
                router.push(gen('/auth/signin'))
              }
            })
          return
        }
      } catch (error) {
        console.log(error)
      }
      return
    }
  }, [loginTypeStateSelector])
}

export default useNoLogin
